import { ResponseBase } from '../Base';
import { DropDownListItem } from '../common/dropDownListResponse';

export interface ContactSimple {
    id: number; 
    fullName: string; 
    email: string;
    cellNumber: string; 
    homeNumber: string; 
    workNumber: string;
    contactTypes: string;
    companyName: string;  
    isActive: boolean;
    xnAddress?: string;
    isLoginActive?: boolean;
    createdDate?: string; 
    lastActivityDate?: string;
}

export const defaultContactSimple: ContactSimple = {
    id: 0, 
    fullName: '', 
    email: '', 
    cellNumber: '', 
    homeNumber: '', 
    workNumber: '', 
    contactTypes: '',
    companyName: '',
    isActive: true,
}

export interface ContactSimpleResponse extends ResponseBase<ContactSimple> {
    companies?: DropDownListItem[];
 }
